import { MutationTree } from 'vuex';
import { IAuthenticationState } from './authentication.types';

const mutations: MutationTree<IAuthenticationState> = {
  setPinCode(state, code: string): void {
    state.pinCode = code;
  },

  setNetworkError(state, error: string): void {
    state.networkError = error;
  },

  setAuthError(state, error: string): void {
    state.authError = error;
  },
};

export default mutations;
